
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image } from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Wird die psychische und emotionale Belastung zu gross, kann unser Hirn Albträume produzieren, die teils sogar wiederkehren. Wie die Wissenschaftsjournalistin Alice Robb schreibt, `}<M mdxType="M">{`haben rund zwei Drittel der Erwachsenen denselben meist negativen Traum mehrmals im Leben.`}</M>{` Der Inhalt kann sehr individuell sein, es gibt aber auch kollektive Horrorszenarien: ins Bodenlose fallen, verfolgt werden, sich nicht bewegen können, zu spät kommen. Dahinter stecken meist Ängste, Stress oder verdrängte Probleme. «Hat man im Traum Angst und läuft vor der Gefahr weg, deutet das oft auf ein Vermeidungsverhalten im Alltag hin. Man will sich einem Problem nicht stellen, was unser träumendes Hirn dann in sehr prägnanten Bildern darstellt», so der Psychologe Michael Schredl. `}<br /><br />{`
Manche Albträume sind so intensiv, dass sie auch tagsüber nachhallen – etwa, wenn der Partner im Traum fremdgegangen ist. Gemäss einer `}<Link href='https://journals.sagepub.com/doi/10.1177/1948550613486678' mdxType="Link">{`US-Studie`}</Link>{` der Universität Maryland sind «vir­tuell» betrogene Frauen am nächsten Tag auf ihren Partner sauer, obwohl der Arme nichts verbrochen hat.`}</p>
    <p>{`Medikamente gegen Albträume gibt es nicht. Man kann aber mit der sogenannten Imagery Rehearsal Therapy im Wachzustand trainieren, den Albtraum ins Positive zu kehren: `}<M mdxType="M">{`Bei einem Sturz ins Bodenlose baut man zum Beispiel einen Fallschirm in den Pyjama ein,`}</M>{` oder man benutzt die Arme als Flügel. Das neue Ende des Traums spielt man dann täglich während zehn Minuten zwei Wochen lang durch. Rund 70 Prozent der Betroffenen träumen danach besser.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;